export default __webpack_public_path__ + "static/media/iot_2.0cf970aa.png";